import { memo } from 'react';

import { useChatHistoryNodeSync } from '../../hooks/useChatHistoryNodeSync';

export const ChatHistoryNodeSync = memo(() => {
  useChatHistoryNodeSync();

  return null;
});

ChatHistoryNodeSync.displayName = 'ChatHistoryNodeSync';
